
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import ImageSelector from '@/components/ImageSelector.vue';

  @Component({
    components: {ImageSelector},
  })
  export default class DlgTrainingTemplateDelete extends Vue {
    @Prop({type: Object, default: null}) private template!: any;

    @Action('admin/trainings/removeTemplate') private deleteTemplate!: any;
    @Action('admin/trainings/readTemplates') private readTemplates!: any;
    @Getter('common/rules/all') private rules!: any;

    private dialog: boolean = false;
    private loading: boolean = false;

    private async del() {
      this.loading = true;
      await this.deleteTemplate(this.template);
      await this.readTemplates({id: this.template.trainingId});
      this.dialog = false;
      this.loading = false;
    }
  }
